import type { MouseEvent } from 'react';

export const handleInPageHashLinkClick = (
  e: MouseEvent<HTMLAnchorElement>,
  href: string
) => {
  if (!href.startsWith('/#')) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

  const id = decodeURIComponent(href.slice(2));
  const el = document.getElementById(id);

  if (el) {
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const url = new URL(window.location.href);
    url.hash = id;
    window.history.replaceState(null, '', url.toString());
    return;
  }

  e.preventDefault();
};

const shouldLogoScrollToTop = () => {
  const p = window.location.pathname;
  return p === '/' || p === '' || p.endsWith('iframe.html');
};

export const handleLandingLogoHomeClick = (e: MouseEvent<HTMLAnchorElement>) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  if (!shouldLogoScrollToTop()) return;
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
  const url = new URL(window.location.href);
  url.hash = '';
  window.history.replaceState(null, '', url.toString());
};
